<template>
    <div class="cafe_navi" id="cafe_navi_default">
        <span class="tab_btns tab_btns_type2" v-if="isAdmin">
            <button class="link_btns #end_btn" :class="{ disabled: !progressing }" id="btn_apply_stop" @click="stopApply">참여종료</button>
        </span>
        <span class="tab_btns tab_btns_type2" v-else>
            <a :href="newArticleUrl" class="link_btns #apply_btn" :class="{ disabled: !progressing }" id="btn_apply" @click="checkPeriod">
                <span class="apply_txt">참여하기</span><span class="ico_cafe write_cafe_btn"></span>
            </a>
        </span>
        <h2>
            <a :href="backUrl" role="button" class="link_pre">
                <strong class="tit_pre"><span class="ico_cafe ico_arr"></span>{{ boardName }}</strong>
            </a>
        </h2>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isAdmin: APPLY_LIST_PROPS.IS_ADMIN,
            boardName: CAFEAPP.BOARDNAME,
            
            grpId: CAFEAPP.GRPID,
            grpCode: CAFEAPP.GRPCODE,
            fldId: CAFEAPP.FLDID,
            
            startDate: null,
            endDate: null,
            progressing: true,
            acceptable: false,
            
            isChecked: false
        };
    },
    computed: {
        newArticleUrl() {
            return `/${this.grpCode}/${this.fldId}/new?boardType=L`;
        },
        backUrl() {
            return `/${this.grpCode}`;
        }
    },
    methods: {
        actionIncomplete(xhr) {
            alert(cafe.EXCEPTION.getMessage(xhr));
            if(xhr.responseJSON && xhr.responseJSON.code == 104){
                window.location.href = `/${this.grpCode}/`;
            } else {
                window.location.href = `/${this.grpCode}/${this.fldId}?boardType=L`;
            }
        },
        checkPeriod(e) {
            if(!this.isChecked) return;
            const now = new Date().getTime();

            let status;
            if(!this.progressing && this.startDate && now < this.startDate) status = "102";
            else if(!this.progressing && this.endDate && this.endDate < now) status = "APPLY_END";
            else if(!this.acceptable) status = "101";

            if(status) {
                e.preventDefault();
                alert(cafe.EXCEPTION.SERVICE_MESSAGE[status]);
            }
        },
        stopApply() {
            if(this.progressing && !confirm("참여 기간이 남았습니다. 그래도 종료하시겠습니까?")) return;
            $.ajax({
                type: "PUT",
                url: `/_apply/${this.grpId}/${this.fldId}/close`,
                contentType: "application/json",
            }).then(function() {
                window.location.href = `/${this.grpCode}/${this.fldId}?boardType=L`; 
            }.bind(this), this.actionIncomplete);
        },
        setPeriodData(data) {
            this.isChecked = true;
            
            this.startDate = data.startDate;
            this.endDate = data.endDate;
            this.progressing = data.progressing;
            this.acceptable = data.acceptable;
        },
        getPeriodData() {
            $.ajax(`/_apply/${this.grpId}/${this.fldId}/check`)
                .then(this.setPeriodData);
        }
    },
    created() {
        this.getPeriodData();
    }
}
</script>
